import { Button } from "@repo/ui";
import { useAuth } from "@stardeck-customer-apps/project-auth";
import { useNavigate } from "react-router-dom";

export function Home() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh grid place-items-center px-6 py-20 bg-[radial-gradient(60%_80%_at_50%_0%,_#ffffff_0%,_#eef2f7_100%)]">
      <div className="max-w-lg w-full text-center space-y-6">
        <h1 className="text-4xl font-semibold tracking-tight">Ultra Simple Admin</h1>
        <p className="text-muted-foreground">A minimal login and admin area. No clutter.</p>
        <div className="flex justify-center gap-3">
          {isAuthenticated ? (
            <Button onClick={() => navigate("/admin")}>Go to Admin</Button>
          ) : (
            <Button onClick={() => navigate("/login")}>Log In</Button>
          )}
        </div>
      </div>
    </div>
  );
}
